<label
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[formGroup]="form"
	[matTooltipDisabled]="!error"
>
	<p class="is-absolute-centered">
		@if (label === ".") {
			<span> {{ label }} </span>
		} @else {
			@if (!labelTemplate) {
				<span> {{ label }} </span>
				<span>
					@if (label !== ".") {
						@if (suffixTemplate) {
							<ng-template [ngTemplateOutlet]="suffixTemplate" [ngTemplateOutletContext]="{ $implicit: suffix }" />
						} @else {
							{{ suffix }}
						}
					}
				</span>
			} @else {
				<ng-template [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{ $implicit: label }" />
			}
		}
	</p>
	<input
		#input
		formControlName="value"
		type="number2"
		[max]="max"
		[min]="min"
		(blur)="onBlurred()"
		(focus)="showInput()"
	/>
</label>
